import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/privacy.scss";

const groups = [
  {
    title: "Shopping & orders",
    items: [
      ["/orders", "Order processing", "Verification, acceptance, availability, fulfilment, and order records."],
      ["/shipping", "Shipping & delivery", "Processing, tracking, delivery estimates, duties, and lost parcels."],
      ["/returns", "Returns & refunds", "Eligibility, exclusions, return shipping, inspection, and refund timing."],
      ["/cancellations", "Order changes & cancellations", "When an order can be changed or cancelled before fulfilment."],
      ["/payments", "Payments & pricing", "Payment authorization, currency, taxes, declines, and refunds."],
      ["/preorders", "Pre-orders & backorders", "Estimated dates, payment timing, mixed baskets, delays, and cancellation."],
      ["/subscriptions", "Subscription terms", "Current recurring-purchase status and protections for any future program."],
      ["/promotions", "Promotions & discount codes", "General rules for offers, codes, gifts, and promotional returns."],
      ["/gift-cards", "Gift card terms", "Terms that apply only when tiporchid gift cards are offered."],
      ["/warranty", "Product care & warranty", "Care responsibilities, defects, remedies, and statutory rights."],
      ["/product-safety", "Product safety & recalls", "Safe use, incident reporting, and recall communications."],
    ],
  },
  {
    title: "Business & sales channels",
    items: [
      ["/wholesale", "Wholesale & corporate orders", "Quotes, approvals, lead times, customization, delivery, and resale terms."],
      ["/marketplaces", "Third-party sales channels", "Receipts, authenticity, seller responsibilities, and impersonation scams."],
      ["/reviews", "Reviews & user content", "Submission rules, moderation, publication rights, privacy, and incentives."],
      ["/security", "Security & fraud prevention", "Payment safeguards, transaction review, phishing, and responsible reports."],
    ],
  },
  {
    title: "Legal, privacy & access",
    items: [
      ["/terms", "Terms of service", "The contract governing site use and purchases."],
      ["/privacy", "Privacy policy", "What information is collected, used, disclosed, retained, and protected."],
      ["/privacy-choices", "Your privacy choices", "How to make a privacy request or manage browser-stored data."],
      ["/cookies", "Cookie policy", "Essential browser storage and third-party service technology."],
      ["/communications", "Email & SMS communications", "Service notices, marketing choices, SMS status, and scam awareness."],
      ["/intellectual-property", "Intellectual property", "Permitted use and how to report suspected infringement."],
      ["/accessibility", "Accessibility statement", "Our accessibility goal, known limits, and feedback process."],
      ["/faqs", "Frequently asked questions", "Plain-language answers about common store questions."],
    ],
  },
];

export default function Policies() {
  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Policies &amp; legal</p>
        <h1>Policy center</h1>
        <p>
          One place to understand shopping, privacy, safety, legal, and
          accessibility practices at {siteConfig.brandName}.
        </p>
        <span>Last reviewed {POLICY_UPDATED}</span>
      </header>

      <div className="policy-layout">
        <PolicyNav current="/policies" />
        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="policies-overview">
            <p className="policy-eyebrow">Start here</p>
            <h2 id="policies-overview">The rules, without the maze.</h2>
            <p>
              Order-specific details shown on a product page, at checkout, or in
              a promotion may supplement these policies. Mandatory rights under
              applicable law continue to apply even when a policy says otherwise.
            </p>
          </section>

          {groups.map((group, index) => (
            <section className="policy-section" key={group.title}>
              <div className="policy-section__heading">
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h2>{group.title}</h2>
              </div>
              <div className="policy-hub-grid">
                {group.items.map(([to, title, description]) => (
                  <Link to={to} key={to}>
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <span aria-hidden="true">Read policy →</span>
                  </Link>
                ))}
              </div>
            </section>
          ))}

          <section className="policy-help" aria-labelledby="policies-help">
            <div>
              <p className="policy-eyebrow">Need clarification?</p>
              <h2 id="policies-help">Ask before you order.</h2>
            </div>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email} <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}
